import gql from "graphql-tag";

const ADD_HOMEOWNER_TRAFFIC = gql`
  mutation addHomeownerTraffic($input: HomeownerTrafficInput!) {
    addHomeownerTraffic(input: $input) {
      message
      code
    }
  }
`;

export default ADD_HOMEOWNER_TRAFFIC;
